import _ from 'lodash';
import numeral from 'numeral';
import isNumber from 'is-number';

export default function getPivotedTableViewRows(lku, lpData, config) {
  // config
  // {
  //   "groupColumn": "loc",
  //   "groupType": "Location",
  //   "headingColumn": "s2", could be: s1, s2, or rs
  //   "headingType": "Stratification", Stratification, Response
  //    "ssColumn": "wn",
  //   "dataRowLabel": "data row label",
  //   "ciRowLabel": "95% CI",
  //   "wnRowLabel": "Weighted No.",
  //   "decimalPlaces": 2
  // }

  const groupByRows = _(lpData).map(config.groupColumn).uniq()
    .map(id => lku[config.groupType][id])
    // when group by year, sort descending
    .orderBy('sort', config.groupColumn === 'yr' ? 'desc' : 'asc')
    .value();

  const stratColumns = _(lpData).map(config.headingColumn).uniq()
    .map(id => lku[config.headingType][id])
    .orderBy('sort', 'asc')
    .value();

  const duplicateRowErrors = [];

  const hasCI = _(lpData).map('lci').filter(x => x).value().length > 0;
  const hasSampleSize = _(lpData).map(config.ssColumn).filter(x => x).value().length > 0;

  function buildDataRow(groupId, groupName, rowType, grpRows, stratCols) {
    let rowLabel;

    if (rowType === 'Data') {
      rowLabel = config.dataRowLabel;
    } else if (rowType === 'CI') {
      rowLabel = config.ciRowLabel;
    } else {
      rowLabel = config.ssRowLabel;
    }

    const tableRowObj = { groupId, group: groupName, label: rowLabel };
    _(stratCols).forEach((col) => {
      // add column for each strat
      const filter = {};
      filter[config.headingColumn] = col.id;
      const groupRowsForThisColumn = grpRows.filter(filter).value();

      let colContent = '';
      if (groupRowsForThisColumn.length === 0) {
        colContent = '';
      } else {
        if (groupRowsForThisColumn.length > 1 && rowType === 'Data') {
          duplicateRowErrors.push(`Duplicate data rows found for group: "${groupName}" and strat: ` +
            `"${col.name}" with id: "${col.id}". Rows found: ${groupRowsForThisColumn.length}.`);
        }
        // use the first row (in case there are duplicate rows)
        const firstRow = groupRowsForThisColumn[0];
        if (rowType === 'Data') {
          const dataValue = firstRow.dv;
          const footNoteSymbol = firstRow.fn;
          const value = isNumber(dataValue)
            ? Number(dataValue).toFixed(config.decimalPlaces)
            : dataValue;
          if (value) {
            if (footNoteSymbol) {
              colContent = `${value}<sup>${footNoteSymbol}</sup>`;
            } else {
              colContent = value;
            }
          } else if (footNoteSymbol) {
            colContent = footNoteSymbol;
          }
        } else if (rowType === 'CI') {
          let lowCI = firstRow.lci;
          let highCI = firstRow.hci;
          lowCI = isNumber(lowCI) ? Number(lowCI).toFixed(config.decimalPlaces) : '';
          highCI = isNumber(highCI) ? Number(highCI).toFixed(config.decimalPlaces) : '';
          colContent = lowCI && highCI ? `${lowCI} - ${highCI}` : '';
        } else {
          const sampleSize = firstRow[config.ssColumn];
          colContent = isNumber(sampleSize) ? numeral(sampleSize).format('0,0') : '';
        }
      }
      // add property for strat column
      tableRowObj[col.id] = colContent;
    });
    return tableRowObj;
  }

  const pivotedTableViewRows = [];
  _(groupByRows).forEach((group) => {
    const groupFilter = {};
    groupFilter[config.groupColumn] = group.id;
    const groupByDataRows = _(lpData).filter(groupFilter);
    pivotedTableViewRows.push(buildDataRow(group.id, group.name, 'Data', groupByDataRows, stratColumns));
    if (hasCI) pivotedTableViewRows.push(buildDataRow(group.id, group.name, 'CI', groupByDataRows, stratColumns));
    if (hasSampleSize) pivotedTableViewRows.push(buildDataRow(group.id, group.name, 'SampleSize', groupByDataRows, stratColumns));
  });

  return {
    pivotedTableViewRows, stratColumns, groupByRows, duplicateRowErrors,
  };
}



// WEBPACK FOOTER //
// ./src/components/LP/TableViewUtil.js